import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { ReconciliationSupplierDetail, ReopenReconciliationPayload } from './types';

const getEndpoint = (supplierId: number) => `ums/v1/cms/reconciliation/suppliers/${supplierId}/reopen`;

type TData = ReconciliationSupplierDetail;
type TError = AxiosError;
type TVariables = ReopenReconciliationPayload;
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useReopenReconciliationApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ month, supplierId }: TVariables) => {
    try {
      const { data } = await http.post(getEndpoint(supplierId), undefined, { params: { month } });
      return data;
    } catch (error: any) {
      if (!error.response?.status) throw error;

      toast({
        description: error.response?.data?.message ?? 'Failed to reopen the reconciliation month',
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: ['reconciliation-reopen'],
  });
}
